<template>
  <div v-if="pageGroupedElements.length">
    <div
      v-for="(page, index) in pageGroupedElements"
      :key="'page-' + index"
      class="position-relative dinA4"
    >
      <img :src="require('@/assets/insular-header-pt.png')" class="mb-0 page__header" />

      <div class="page__container">
        <div
          v-for="(combo, comboIndex) in page"
          :key="'combo-' + comboIndex"
        >
          <div
            v-if="combo[0] && combo[0].type === 'table'"
            class="d-flex justify-center"
            :class="{ 'mt-10': comboIndex > 0 }"
          >
            <PdfProductTable
              v-for="(id, i) in combo[0].ids"
              :key="'table-' + i"
              :type="combo[0].tableType"
              :tableData="productTableList[id]"
              :tableId="id"
              :image="(combo[0].images && combo[0].images[id]) || combo[0].imageUrl"
              :descKey="getProduct(id) ? getProduct(id).desc_key : ''"
            />
          </div>

          <div
            v-if="combo[1] && combo[1].type === 'text'"
            class="d-flex justify-center mt-5"
          >
            <div :class="combo[1].extraWide ? 'small-letter-section-extrawide' : 'small-letter-section'">
              <p
                v-if="combo[1].title"
                class="small-letter-font small-letter-font--bold mb-2"
              >
                {{ combo[1].title }}
              </p>
              <p
                v-if="combo[1].intro"
                class="small-letter-font small-letter-font--bold mb-0"
              >
                {{ combo[1].intro }}
              </p>
              <ul class="small-letter-font justify-text spaced-list">
                <li
                  v-for="(elementList, listIndex) in combo[1].list"
                  :key="'textList-' + listIndex"
                  v-html="elementList"
                />
              </ul>
              <p
                v-if="combo[1].outro"
                class="small-letter-font justify-text mt-6 mb-0"
                v-html="combo[1].outro"
              />
            </div>
          </div>
        </div>
        <div v-if="index === pageGroupedElements.length - 1" class="note-section mt-10">
          <p class="small-letter-font justify-text" v-html="$t('NOTE_INSULAR')"></p>
        </div>
      </div>
      
      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST, GET_PRODUCT } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt-nexus/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt-nexus/Footer'

export default {
  name: 'InsularTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        // CTT 24h (Ilhas PT) - Madeira e Açores
        {
          type: 'table',
          ids: ['CPT24_RAA','CPT24_LPMA'],
          tableType: 'ilhas-pt-aereo',
          images: {
            CPT24_RAA: require('@/assets/ilhas-pt.png')
          },
        },
        {
          type: 'text',
          title: 'Características do serviço CTT 24h Ilhas PT:',
          relatedTableType: 'ilhas-pt-aereo',
          extraWide: true,
          list: [
            '• <b>Oferta:</b> B2C; B2B: <b>Produto:</b> CTT 24h (19H), CTT 24hM (19M), e24h (Para Amanhã); <b>Fluxo:</b> PT Continente > PT Açores, PT Madeira; PT Açores, PT Madeira > PT Continente.',
            '• <b>Oferta:</b> B2C: <b>Produto:</b> Devolução Fácil; <b>Fluxo:</b> PT Açores, PT Madeira > PT Continente.',
            '• <b>Peso máximo por volume:</b> Madeira 20 Kg, Açores 5 Kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 167kg/ m3 (meio de transporte aéreo).',
            '• <b>Serviços Adicionais CTT 24h (19H):</b> Cobrança, Proteção Extra, Back, DDA, SMS / <b>CTT 24hM (19M):</b> Cobrança, Proteção Extra, DDA, SMS.',
            '• <b>Serviços Adicionais e24h (Para Amanhã):</b> Cobrança, Proteção Extra, Back, DDA, Alteração Dados da Encomenda, Entrega Conjunta, 2 Tentativas de Entrega, Entrega em Ponto Collectt (A maior rede de pontos Ibérica).',
            '• <b>Serviços Adicionais Devolução Fácil:</b> Proteção Extra.'
          ]
        },
        // CTT Marítimo (Ilhas PT) - Madeira e Açores
        {
          type: 'table',
          ids: ['CPT48'],
          imageUrl: require('@/assets/ilhas-pt.png'),
          tableType: 'ilhas-pt-maritimo',
        },
        {
          type: 'text',
          title: 'Características do serviço CTT Marítimo Ilhas PT:',
          relatedTableType: 'ilhas-pt-maritimo',
          extraWide: true,
          list: [
            '• <b>Oferta:</b> B2B, B2C; <b>Produto:</b> CTT 48h, e48h (Em 2 Dias); <b>Fluxo:</b> PT Continente > PT Açores, PT Madeira; PT Açores, PT Madeira > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 333kg/ m3 (meio de transporte marítimo).',
            '• <b>Serviços Adicionais CTT 48h (48H):</b> Cobrança, Proteção Extra, Back, DDA, SMS.',
            '• <b>Serviços Adicionais e48h (Em 2 Dias):</b> Cobrança, Proteção Extra, 2 Tentativas de Entrega, Alteração Dados da Encomenda, Entrega Conjunta.'
          ]
        },
        // CTT 24h (Baleares)
        {
          type: 'table',
          imageUrl: require('@/assets/cttbaleares-icon.png'),
          ids: ['CBA24'],
          tableType: 'baleares-aereo',
        },
        {
          type: 'text',
          title: 'Características do serviço CTT 24h Baleares:',
          relatedTableType: 'baleares-aereo',
          extraWide: true,
          list: [
            '• <b>Oferta:</b> B2B, B2C; <b>Produto:</b> CTT 24h (19H), CTT 24hM (19M), CTT e24h (Para Amanhã); <b>Fluxo:</b> PT Continente > ES Baleares.',
            '• <b>Oferta:</b> B2C; <b>Produto:</b> Devolução Fácil; <b>Fluxo:</b> ES Baleares > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 Kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 167kg/ m3 (meio de transporte aéreo).',
            '• <b>Serviços Adicionais CTT 24h (19H):</b> Cobrança, Proteção Extra, Back, DDA, SMS / <b>CTT 24hM (19M):</b> Cobrança, Proteção Extra, DDA, SMS.',
            '• <b>Serviços Adicionais CTT e24h (Para Amanhã):</b> Cobrança, Proteção Extra, Back, DDA, Alteração Dados da Encomenda, Entrega Conjunta, 2 Tentativas de Entrega.',
            '• <b>Serviços Adicionais Devolução Fácil:</b> Proteção Extra.'
          ]
        },
        // CTT Marítimo (Baleares)
        {
          type: 'table',
          ids: ['CBA48'],
          imageUrl: require('@/assets/cttbaleares-icon.png'),
          tableType: 'baleares-maritimo',
        },
        {
          type: 'text',
          title: 'Características do serviço CTT Marítimo Baleares:',
          relatedTableType: 'baleares-maritimo',
          extraWide: true,
          list: [
            '• <b>Oferta:</b> B2B, B2C; <b>Produto:</b> CTT 48h, e48h (Em Dois Dias); <b>Fluxo:</b> PT Continente > ES Baleares.',
            '• <b>Peso máximo por volume:</b> 30 Kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 333kg/ m3 (meio de transporte marítimo).',
            '• <b>Serviços Adicionais CTT 48h (48H):</b> Cobrança, Proteção Extra, Back, DDA, SMS.',
            '• <b>Serviços Adicionais CTT e48h (Em Dois Dias):</b> Cobrança, Proteção Extra, 2 Tentativas de Entrega, Alteração Dados da Encomenda, Entrega Conjunta.'
          ]
        },
        // CTT 24h (Canárias)
        {
          type: 'table',
          imageUrl: require('@/assets/cttcanarias-icon.png'),
          ids: ['CCA24'],
          tableType: 'canarias-aereo',
        },
        {
          type: 'text',
          title: 'Características do serviço CTT 24h Canárias:',
          relatedTableType: 'canarias-aereo',
          extraWide: true,
          list: [
            '• <b>Oferta:</b> B2B, B2C; <b>Produto:</b> CTT 24h (19H), CTT 24hM (19M), e24h (Para Amanhã); <b>Fluxo:</b> PT Continente > ES Canarias.',
            '• <b>Oferta:</b> B2C; <b>Produto:</b> Devolução Fácil; <b>Fluxo:</b> ES Canarias > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 Kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Despacho Único Aduaneiro (DUA):</b> Disponível para destinos com sistema Alfandegário; Aos valores indicados na tabela acresce a taxa no valor de 22,50€.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 167kg/ m3 (meio de transporte aéreo).',
            '• <b>Serviços Adicionais CTT 24h (19H):</b> Cobrança, Proteção Extra, Back, DDA, SMS / <b>CTT 24hM (19M):</b> Cobrança, Proteção Extra, DDA, SMS.',
            '• <b>Serviços Adicionais CTT e24h (Para Amanhã):</b> Cobrança, Proteção Extra, Back, DDA.',
            '• <b>Serviços Adicionais Devolução Fácil:</b> Proteção Extra.'
          ]
        },
        // CTT Marítimo (Canárias)
        {
          type: 'table',
          ids: ['CCA48'],
          imageUrl: require('@/assets/cttcanarias-icon.png'),
          tableType: 'canarias-maritimo',
        },
        {
          type: 'text',
          title: 'Características do serviço CTT Marítimo Canárias:',
          relatedTableType: 'canarias-maritimo',
          extraWide: true,
          list: [
            '• <b>Oferta:</b> B2B, B2C; <b>Produto:</b> CTT 48h, e48h (Em Dois Dias); <b>Fluxo:</b> PT Continente > ES Canárias.',
            '• <b>Peso máximo por volume:</b> 30 Kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 333kg/ m3 (meio de transporte marítimo).',
            '• <b>Serviços Adicionais CTT 48h (48H):</b> Cobrança, Proteção Extra, Back, DDA, SMS.',
            '• <b>Serviços Adicionais CTT e48h (Em Dois Dias):</b> Cobrança, Proteção Extra, 2 Tentativas de Entrega, Alteração Dados da Encomenda, Entrega Conjunta.'
          ]
        },
        // CTT 24h (Outros Destinos) - Ceuta, Melilla, Gibraltar
        {
          type: 'table',
          imageUrl: require('@/assets/cttotherdest-icon.png'),
          ids: ['C24_OTHER'],
          tableType: 'outros-destinos',
        },
        {
          type: 'text',
          title: 'Características do serviço Outros Destinos:',
          relatedTableType: 'outros-destinos',
          extraWide: true,
          list: [
            '• <b>Oferta:</b> B2B, B2C; <b>Produto:</b> CTT 24h (19H), CTT 24hM (19M), e24h (Para Amanhã); <b>Fluxo:</b> PT Continente > Ceuta, Melilla, Gibraltar.',
            '• <b>Oferta:</b> B2C; <b>Produto:</b> Devolução Fácil; <b>Fluxo:</b> Ceuta, Melilla, Gibraltar > PT Continente.',
            '• <b>Peso máximo por volume:</b> 30 kg.',
            '• <b>Medidas máximas por volume:</b> A soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
            '• <b>Medidas mínimas por volume:</b> Comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
            '• <b>Cubicagem:</b> Conversão Volumétrica 167 kg/m3 (meio de transporte aéreo).',
            '• <b>Despacho Único Aduaneiro (DUA):</b> Disponível para destinos com sistema Alfandegário; Aos valores indicados na tabela acresce a taxa no valor de 22,50€.',
            '• <b>Serviços Adicionais CTT 24h (19H):</b> Cobrança, Proteção Extra, Back, DDA, SMS / <b>CTT 24hM (19M):</b> Cobrança, Proteção Extra, DDA, SMS.',
            '• <b>Serviços Adicionais CTT e24h (Para Amanhã):</b> Cobrança, Proteção Extra.',
            '• <b>Serviços Adicionais Devolução Fácil:</b> Proteção Extra.'
          ]
        },
      ],
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST, GET_PRODUCT]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },

    combinedElements() {
      const combos = []
      const { elements } = this
      let i = 0

      while (i < elements.length) {
        const current = elements[i]

        if (current.type === 'table') {
          const selectedIds = current.ids.filter(id => this.isProductSelected(id))
          if (!selectedIds.length) {
            i++
            continue
          }

          const tableCopy = { ...current, ids: selectedIds }

          const nextEl = elements[i + 1]
          if (
            nextEl &&
            nextEl.type === 'text' &&
            nextEl.relatedTableType === tableCopy.tableType
          ) {
            combos.push([tableCopy, nextEl])
            i += 2
          } else {
            combos.push([tableCopy])
            i++
          }
        }
        else {
          i++
        }
      }
      return combos
    },


    pageGroupedElements() {
      const combos = this.combinedElements
      if (!combos.length) return []
      return combos.map(combo => [combo])
    },
  },
  methods: {
    isProductSelected(tableId) {
      const product = this[GET_PRODUCT](tableId)
      return product && product.isPreSelected === true
    },
    getProduct(productId) {
      return this[GET_PRODUCT](productId)
    },
  },
  created() {
    this.$emit('updateTotalPages', { InsularTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InsularTables')
  },
}
</script>
